
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import global from '../../../static/js/global.js'
export default {
components:{
Group,
Swiper,
Flexbox,
FlexboxItem
},
data(){
return{
loopList:[]
}
},
beforeMount(){
let obj = new Object();
obj.img = global.imgUrl + '/image/banner1.png'
let obj2 = new Object();
obj2.img = global.imgUrl + '/image/banner2.jpg'
this.loopList.push(obj)
this.loopList.push(obj2);
},
mounted(){
if(this.$router.history.current.path == "/yellowpage"){
document.title = "便民黄页";
}
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/yellowPage.vue